var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.475 7.63761L6.275 3.42511C6.225 3.37511 6.17083 3.33961 6.1125 3.31861C6.05417 3.29761 5.99167 3.28727 5.925 3.28761C5.85833 3.28761 5.79583 3.29794 5.7375 3.31861C5.67917 3.33927 5.625 3.37477 5.575 3.42511L1.3625 7.63761C1.24583 7.75427 1.1875 7.9001 1.1875 8.07511C1.1875 8.25011 1.25 8.40011 1.375 8.52511C1.5 8.65011 1.64583 8.71261 1.8125 8.71261C1.97917 8.71261 2.125 8.65011 2.25 8.52511L5.925 4.85011L9.6 8.52511C9.71667 8.64177 9.8605 8.70011 10.0315 8.70011C10.2025 8.70011 10.3503 8.63761 10.475 8.51261C10.6 8.38761 10.6625 8.24177 10.6625 8.07511C10.6625 7.90844 10.6 7.76261 10.475 7.63761Z",
    fill: "#525259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrrow);
export default __webpack_public_path__ + "static/media/arrrow.33afbf73c7bc4848449c7aad92ff6085.svg";
export { ForwardRef as ReactComponent };